<template>
  <div class="sky__inspiration py-16 pb-16 lg:pb-60 px-4 md:px-8">
    <div>
      <div class="big-container mx-auto">
        <h3 class="leading-tight text-center mb-8">
          <span class="block text-2xl lg:text-3xl font-baskerville">
            Trouver l'
            <span class="font-funny text-3xl lg:text-5xl">
              inspiration
            </span>
          </span>
          <span class="block font-geologica font-thin">
            Des idées plein les yeux pour vos envies
          </span>
        </h3>
        <div class="flex gap-8 justify-center">
          <nuxt-link :to="$helpers.makeUri(inspirationItem.path, 'category')" v-for="inspirationItem in inspiration" class="sky__inspiration-img relative">
            <div class="absolute top-0 left-0 w-full h-full flex items-center justify-end p-8 flex-col">
              <div class="text-white text-center font-geologica text-lg md:text-2xl lg:text-3xl uppercase">
                {{ inspirationItem.attributes.name }}
              </div>
              <div class="text-white text-center font-geologica font-light uppercase tracking-wider text-xs">
                {{ inspirationItem.attributes.texte_inspiration }}
              </div>
            </div>
            <img
              :src="`${inspirationItem.attributes.image_home_page_inspiration}?w=1000&h=1000&format=webp`"
              loading="lazy"
              :alt="inspirationItem.attributes.name"
              width="1000"
              height="1000"
            >
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkyBtn from '../general/SkyLightBtn'
export default {
  components: {
    SkyBtn
  },
  props: {
    inspiration: {
      required: true,
      type: Object
    }
  },
  computed: {
    allTitleExceptLastWord () {
      return this.inspiration.attributes.titre.split(' ').slice(0, -1).join(' ')
    },
    lastWord () {
      return this.inspiration.attributes.titre.split(' ').slice(-1).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__inspiration {
  background: url('https://d1qm763jdit350.cloudfront.net/aea605bf-bdc4-444a-8507-1e9805fc6d1b');
  background-size: cover;
  background-position: bottom
}
  .sky__inspiration-img {
    min-width: 200px;
    max-width: 1000px;

  }
</style>
